<template>
  <div class="car-info">
    <div class="car-info__left">
      <div class="car-info__image-wrapper">
        <img
          :src="image.src"
          :alt="image.alt"
          class="car-info__image"
        >
      </div>
    </div>
    <div class="car-info__label-wrapper">
      <h2 class="car-info__year" v-html="modYear" />
      <p class="car-info__modification" v-html="modification" />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'CarInfo',
    props: {
      image: {
        type: Object,
        required: true,
        validator (image) {
          return 'src' in image &&
            'alt' in image
        }
      },
      year: {
        type: String,
        required: true
      },
      modification: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        modYear: ''
      }
    },
    computed: {
      ...mapGetters(['getModel'])
    },
    async created () {
      const data = await this.fetchYearPageData({ model: this.getModel })
      let year = ''
      data.years.forEach(item => {
        if (this.year.includes(item.label)) {
          year = this.year.replace(item.label, '<br>' + item.label)
          this.modYear = year
        }
      })
      if (!year) {
        year = this.year
        this.modYear = year
      }
    },
    methods: {
      ...mapActions(['fetchYearPageData'])
    }
  }
</script>

<style lang="scss">
  .car-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 35px;

    @include mobile {
      flex-direction: column;
      margin-bottom: 20px;
    }

    &__left {
      width: 335px;

      @include mobile {
        width: 100%;
      }
    }

    &__image {
      &-wrapper {
        width: 280px;
        margin: 0 auto;

        @include mobile {
          width: 100%;
          max-width: 290px;
          margin: 0 auto;
          margin-bottom: 25px;
        }
      }

      width: 100%;
      height: auto;
    }

    &__label-wrapper {
      width: 335px;

      @include mobile {
        width: 100%;
        max-width: 200px;
        margin: 0 auto;
        text-align: center;
      }
    }

    &__year {
      min-height: 54px;
      margin-bottom: 5px;
      text-align: left;

      @include mobile {
        text-align: center;
      }
    }

    &__modification {
      font-size: 16px;
      color: $c-gray-dark;
      text-align: left;

      @include mobile {
        text-align: center;
      }
    }
  }
</style>
